"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var data_store_1 = __importDefault(require("../../data-store"));
var storable_data_service_1 = __importDefault(require("../../storable-data-service"));
var parking_spot_service_1 = __importDefault(require("./parking-spot-service"));
var ParkingSpotApiV2 = /** @class */ (function () {
    function ParkingSpotApiV2(session) {
        this.parkingSpotApiStore = new data_store_1.default();
        this.parkingSpotService = new parking_spot_service_1.default(session);
        this.storableDataService = new storable_data_service_1.default(this.parkingSpotApiStore);
    }
    ParkingSpotApiV2.prototype.loadAll = function (options) {
        var _this = this;
        return this.storableDataService.loadAll('loadAll', function () { return _this.parkingSpotService.loadAll(); }, options);
    };
    ParkingSpotApiV2.prototype.get = function (id) {
        return this.parkingSpotApiStore.get(id);
    };
    ParkingSpotApiV2.prototype.getAll = function () {
        return this.parkingSpotApiStore.getAll();
    };
    return ParkingSpotApiV2;
}());
exports.default = ParkingSpotApiV2;
//# sourceMappingURL=parking-spot-api.js.map